// extracted by mini-css-extract-plugin
module.exports = {"pa_pagination_className":"categoryPagination_pa_pagination_className__uZ1JY"};